import type { PropsWithChildren } from 'react'

import { AssignWallItemToZoneTransformerComponent } from '../transformers/assign-wall-item-to-zone-transformer'
import { DndTransformerComponent } from '../transformers/dnd-transformer'

export const OnLoadProvider = ({ children }: PropsWithChildren) => {
  return (
    <>
      {/* TODO: Hidden on client's request. */}
      {/* <StainlessSafeEnvironmentFixDialog /> */}
      <DndTransformerComponent>
        <AssignWallItemToZoneTransformerComponent>{children}</AssignWallItemToZoneTransformerComponent>
      </DndTransformerComponent>
    </>
  )
}
